module.exports = __webpack_public_path__ + "static/media/01_b_photo.8274e685.jpg";